import { connect, ConnectedProps } from "react-redux";
import * as jwt_decode from "jwt-decode";
import { AppState } from "../../../../redux/reducers";
import * as ImputationsStore from "../../../../redux/middleware/CashFlow-PaymentImputations.Middleware";
import * as PersonsStore from "../../../../redux/middleware/Persons.Middleware";
import { PaymentImputation } from "../../../../models/Entities/CashFlow/Payment/PaymentImputation";
import { nameOf } from "../../General/Cashflow.General.Functions";

export interface IProps {
    paymentId: number;
    showTitle?: boolean;
}

const mapStateToProps = (state: AppState, ownProps: IProps) => {
    const tenantId = state?.oidc?.user?.access_token
        ? ((jwt_decode.jwtDecode(state.oidc.user.access_token) as { tenantId?: string })?.tenantId ?? '')
        : '';
    const persons = state.Persons?.list ?? [];

    return {
        imputations: state.CashFlowPaymentImputations?.imputations ?? [] as PaymentImputation[],
        isLoadingImputations: state.CashFlowPaymentImputations?.isLoadingImputations ?? false,
        successLoadingImputations: state.CashFlowPaymentImputations?.successLoadingImputations,
        failOnLoadingImputations: state.CashFlowPaymentImputations?.failOnLoadingImputations ?? false,
        isRollingBack: state.CashFlowPaymentImputations?.isRollingBack ?? false,
        successRollingBack: state.CashFlowPaymentImputations?.successRollingBack,
        failOnRollingBack: state.CashFlowPaymentImputations?.failOnRollingBack ?? false,
        isCreatingImputation: state.CashFlowPaymentImputations?.isCreatingImputation ?? false,
        successCreatingImputation: state.CashFlowPaymentImputations?.successCreatingImputation,
        failOnCreatingImputation: state.CashFlowPaymentImputations?.failOnCreatingImputation ?? false,
        error: state.CashFlowPaymentImputations?.error,
        /** Nombre visible de una contraparte por su identificador. */
        NameOf: (identifier: string | undefined) => nameOf(persons, tenantId, identifier || '')
    };
};

const mapDispatchToProps = {
    ...ImputationsStore.actionCreators,
    GetAllPersons: PersonsStore.actionCreators.GetAllPersons
};

export const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = IProps & ConnectedProps<typeof connector>;
